
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 mt-24 rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-white mb-8"></h3>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-6 py-3 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Randevu Al
            </Link>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-6">Sayfalar</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/hakkimda" className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  Hakkımda
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/makaleler" className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  Makaleler
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  İletişim
                </Link>
              </li>
              <li>
                <a href="/gizlilik-etik" className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  Gizlilik ve Etik
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-white mb-6">Bizi Takip Edin</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://www.instagram.com/psk.esraerten?igsh=MTUwNjR3ZG5ieWFoaA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line mr-2"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/in/esra-erten-351766148" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-300 text-sm hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-line mr-2"></i>
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2025 Tüm hakları saklıdır.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
